var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 28,
    rx: 4.5,
    fill: "white",
    stroke: "#DCE0E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 10.5417C18.2949 10.5417 18.6977 10.7085 18.9946 11.0055C19.2915 11.3024 19.4583 11.7051 19.4583 12.1251M22.625 12.1251C22.6252 12.867 22.4516 13.5986 22.1182 14.2614C21.7847 14.9242 21.3006 15.4996 20.7047 15.9416C20.1088 16.3836 19.4176 16.6798 18.6866 16.8066C17.9556 16.9334 17.2051 16.8871 16.4951 16.6716L14.7083 18.4584H13.125V20.0417H11.5417V21.6251H9.16667C8.9567 21.6251 8.75534 21.5417 8.60687 21.3932C8.45841 21.2447 8.375 21.0434 8.375 20.8334V18.7861C8.37504 18.5762 8.45848 18.3749 8.60696 18.2264L13.3285 13.5049C13.1309 12.8518 13.0764 12.1638 13.1686 11.4877C13.2608 10.8116 13.4976 10.1634 13.8628 9.58701C14.2281 9.01066 14.7132 8.51977 15.2852 8.14774C15.8572 7.77572 16.5027 7.5313 17.1776 7.43111C17.8526 7.33093 18.5412 7.37734 19.1966 7.56719C19.852 7.75703 20.4588 8.08585 20.9757 8.53126C21.4926 8.97667 21.9075 9.52823 22.1921 10.1484C22.4767 10.7685 22.6243 11.4427 22.625 12.1251Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.539756ee99e462f15016f8ffbbc8de40.svg";
export { ForwardRef as ReactComponent };